// extracted by mini-css-extract-plugin
export default {"loading-dot":"loading-dot_e61Yx","loadingDot":"loading-dot_e61Yx","dot":"dot_xIuoe","small":"small_THUtJ","normal":"normal_wtfyb","large":"large_VpX2_","jump":"jump_dzYYV"};